/**
 * De sessie kan niet hersteld worden en de gebruiker moet opnieuw inloggen.
 *
 * Bewust een eigen module: `meFailure.ts` moet deze fout kunnen herkennen
 * zonder `msalAuth.ts` — en daarmee heel MSAL — in zijn importgraaf te trekken.
 */
export class SessionExpiredError extends Error {
  constructor() {
    super('Sessie verlopen — opnieuw inloggen vereist.');
    this.name = 'SessionExpiredError';
  }
}
